import { twMerge } from "tailwind-merge";
import logoSvg from "@themes/pollinator/assets/logos/pollinator.svg";
import altLogoSvg from "@themes/pollinator/assets/logos/pollinator_alt.svg";

export type Props = {
  /** Additional CSS classes */
  className?: string;
  /** Logo size variant */
  size?: "sm" | "md" | "lg";
  /** Theme variant */
  theme?: "light" | "dark";
};

/**
 * The Pollinator logo component with size and theme variants.
 */
export function PollinatorLogo({
  className,
  size = "sm",
  theme = "dark",
}: Props) {
  return (
    <div
      className={twMerge(
        "w-40",
        size === "sm" && "w-24",
        size === "md" && "w-36",
        size === "lg" && "w-64",
        "text-brand-800",
        className
      )}
      data-testid="pollinator-logo"
    >
      <img
        src={theme === "light" ? altLogoSvg : logoSvg}
        alt="Pollinator logo"
        className="w-full object-contain"
        data-testid="pollinator-logo-image"
      />
    </div>
  );
}

export default PollinatorLogo;

